export default function CheckBoxForm({ form, field, onChange, ...props }) {

  return (
    <C.CheckBox
      value={ form[field].value }
      onChange={ value => {
        form.update(field, value)
        if (!onChange) return
        onChange(value)
      } }
      error={ form[field].error }
      { ...props }
    />
  )
}
